import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { ChevronRight } from 'lucide-react';

export default function RegistrationSection() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <section
      id="register-section"
      className="py-20 md:py-32 px-4 md:px-12 lg:px-24 bg-[#1C1917]"
    >
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Ready to Begin?
        </h2>
        <p className="text-white/60 text-lg mb-10">
          This programme is currently available by invitation. If you've received an invitation,
          log in to access your personal dashboard and session schedule.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10 space-y-6">
          {user ? (
            <>
              <p className="text-white/80 text-base">
                Welcome back, <span className="text-white font-semibold">{user.name}</span>.
                Your programme is ready for you.
              </p>
              <Button
                onClick={() => navigate('/dashboard')}
                className="w-full h-14 bg-[#9A3B26] hover:bg-[#7A2E1E] text-white rounded-2xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
              >
                Go to My Dashboard
                <ChevronRight className="h-5 w-5" />
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => navigate('/auth?mode=login')}
                className="w-full h-14 bg-[#9A3B26] hover:bg-[#7A2E1E] text-white rounded-2xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
              >
                Login to Your Account
                <ChevronRight className="h-5 w-5" />
              </Button>
              <p className="text-white/40 text-sm">
                Don't have an account?{' '}
                <a
                  href="https://wa.me/918089143192"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/60 hover:text-white underline underline-offset-2 transition-colors"
                >
                  Contact us at +91 8089143192
                </a>
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
